import { fn } from '@ember/helper';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { PrismButton, PrismCard } from '@mylighthouse/prism-ember';
import HotelAndMarketRevenueInsightBaseSegmentationBlockBase, {
  type HotelAndMarketRevenueInsightBaseSegmentationBlockBaseSignature,
} from 'lumen/components/hotel-and-market/revenue-insight/base/segmentation-block-base';
import HotelAndMarketRevenueInsightBlockList from 'lumen/components/hotel-and-market/revenue-insight/block-list';
import HotelAndMarketRevenueInsightHotelBlockHotelBlockItem from 'lumen/components/hotel-and-market/revenue-insight/hotel-block/hotel-block-item';
import HotelAndMarketRevenueInsightHotelBlockHotelBlockLoading from 'lumen/components/hotel-and-market/revenue-insight/hotel-block/hotel-block-loading';
import HotelAndMarketRevenueInsightHotelBlockHotelBlockTitle from 'lumen/components/hotel-and-market/revenue-insight/hotel-block/hotel-block-title';
import type { HotelSortBy } from 'lumen/utils/constants/ri-constant-values';

interface HotelAndMarketRevenueInsightHotelBlockHotelBlockSignature extends HotelAndMarketRevenueInsightBaseSegmentationBlockBaseSignature {
  Args: HotelAndMarketRevenueInsightBaseSegmentationBlockBaseSignature['Args'] & {
    setSortHotelsAscending: (ascending: boolean) => void;
    setSortHotelsBy: (sortBy: HotelSortBy) => void;
    showFullPortfolio: boolean;
    sortHotelsAscending: boolean;
    sortHotelsBy: HotelSortBy;
    updateIsSearchActive: (isSearchActive: boolean) => void;
  };
}

export default class HotelAndMarketRevenueInsightHotelBlockHotelBlock extends HotelAndMarketRevenueInsightBaseSegmentationBlockBase<HotelAndMarketRevenueInsightHotelBlockHotelBlockSignature> {
  itemComponent = HotelAndMarketRevenueInsightHotelBlockHotelBlockItem;

  @computed(
    'args.{segmentation.segmentationName,filterLimits,isLoading,segmentationFilterClicked,visibleKpis,kpi,showFullPortfolio}',
    'segmentationBlockIdx',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get contentParams() {
    return {
      ...super.contentParams,
      kpi: this.args.kpi,
      showFullPortfolio: this.args.showFullPortfolio,
    };
  }

  @action
  toggleSearch(isEnabled: boolean): void {
    this.updateIsSearchActive(isEnabled);
  }

  <template>
    <PrismCard
      @contentLayout="noPadding"
      class="ic-product-tour-ri-multi--hotel-block hotel-block segmentation-block-card segmentation-block-card--with-show-all"
    >
      <:header>
        <HotelAndMarketRevenueInsightHotelBlockHotelBlockTitle
          @params={{this.titleParams}}
          @setSortHotelsAscending={{@setSortHotelsAscending}}
          @setSortHotelsBy={{@setSortHotelsBy}}
          @sortHotelsAscending={{@sortHotelsAscending}}
          @sortHotelsBy={{@sortHotelsBy}}
        />
      </:header>

      <:headerAfter>
        {{#if this.isSearchActive}}
          <PrismButton
            @buttonType="ghost"
            @icon="cross"
            @onClick={{fn this.toggleSearch false}}
          />
        {{/if}}
      </:headerAfter>

      <:content>
        <div class="card-title-content card-content">
          {{#if @isLoading}}
            <HotelAndMarketRevenueInsightHotelBlockHotelBlockLoading />
          {{else}}
            <HotelAndMarketRevenueInsightBlockList
              @items={{this.visibleSegmentations}}
              {{! @glint-expect-error }}
              @listItemComponent={{this.itemComponent}}
              @maxValues={{this.maxBlockValues}}
              @params={{this.contentParams}}
            />
          {{/if}}
        </div>
      </:content>
    </PrismCard>
  </template>
}
